import { render, staticRenderFns } from "./AllAssignmentsList.vue?vue&type=template&id=53269212&scoped=true&"
import script from "./AllAssignmentsList.vue?vue&type=script&lang=js&"
export * from "./AllAssignmentsList.vue?vue&type=script&lang=js&"
import style0 from "./AllAssignmentsList.vue?vue&type=style&index=0&id=53269212&prod&lang=css&"
import style1 from "./AllAssignmentsList.vue?vue&type=style&index=1&id=53269212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53269212",
  null
  
)

export default component.exports